module.exports = __webpack_public_path__ + "assets/images/boundaries/keys-four-new-smc/key-1-2015.svg?v=fbab5387";